import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Common from '../entities/common'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
interface CommonState extends ListState<Common>{
    editCommon:Common
}
class UserMutations extends ListMutations<Common>{

}
class CommonModule extends ListModule<CommonState,any,Common>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<Common>(),
        loading:false,
        editCompany:new Common(),
        AppName:''
    }
    actions={
        
        async getCompanyName(context:ActionContext<CommonState,any>){
            let reponse=await Ajax.get('/api/services/app/Common/GetCompanyName');
            //console.log(reponse.data.result.companyName);
            context.state.AppName=reponse.data.result.companyName;
        },
        async changpassword(context:ActionContext<CommonState,any>,payload:any){
            await Ajax.post('/api/services/app/Common/ChangePassword',payload.data);
        },
        async editcompanyacname(context:ActionContext<CommonState,any>,payload:any){
            await Ajax.post('/api/services/app/Common/EditCompanyacName',payload.data);
        },
    };
    mutations={
        setCurrentPage(state:CommonState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:CommonState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:CommonState,common:Common){
            
            state.editCommon=common;
            //console.log(state.editFloor);
        }
        
    }
}
const commonModule=new CommonModule();
export default commonModule;